import { LRParser } from '@lezer/lr';
import { LRLanguage, LanguageSupport, bracketMatching } from '@codemirror/language';
import { styleTags, tags } from '@lezer/highlight';

// This file was generated by lezer-generator. You probably shouldn't edit it.
const spec_singleByteIdentifier = {__proto__:null,"~":36, "`":36, "!":36, "@":36, "$":36, "+":36, "-":36, "*":36, "/":36, "%":36, "|":36, "&":36, "^":36, "[":36, "]":36, "\\":36, ";":36, "<":36, ">":36, "=":36, ",":36, ".":36, "?":36, "(":36, ")":36};
const spec_wordIdentifier = {__proto__:null,and:40, or:40, xor:40, print:40, p:40, n:40, puts:40, rand:40, do:40, while:40, until:40, if:40, abs:40, zip:40, base:40};
const parser = LRParser.deserialize({
  version: 14,
  states: "!vQVQPOOOOQO'#C_'#C_OOQO'#C`'#C`OOQO'#Cl'#ClOqQPO'#CeOxQPO'#CfOOQO'#Ck'#CkOOQO'#Ch'#ChQVQPOOOOQO,59P,59PO!^QPO,59POOQO,59Q,59QOOQO-E6f-E6fOOQO1G.k1G.k",
  stateData: "!e~OPOS~OTROUROWSOZTOaQObPOcQOdPO~OVXO~PVOTROUROaQObPOcQOdPO~OV]O~PVO",
  goto: "!YaPPPbbPPPPiiPoPPy!PZROSTWYXUOSWYQWOQYST[WYXVOSWYWUOSWYRZT",
  nodeNames: "⚠ LineComment Program Builtin Identifier String Number } { Block Assignment :",
  maxTerm: 20,
  nodeProps: [
    ["openedBy", 7,"{"],
    ["closedBy", 8,"}"]
  ],
  skippedNodes: [0,1],
  repeatNodeCount: 1,
  tokenData: "'x~RdOr!ars!fst$Ztw!awx$ix}!a}!O&X!O!Q!a!Q![&i![!]&s!]!c!a!c!}&x!}#R!a#R#S&x#S#T!a#T#o&x#o#p'n#p#q!a#q#r's#r~!a~!fOa~~!kTa~Or!zrs#^s#O!z#O#P#c#P~!z~!}TOr!zrs#^s#O!z#O#P#c#P~!z~#cOT~~#fTOr!zrs#us#O!z#O#P#c#P~!z~#zTT~Or!zrs#^s#O!z#O#P#c#P~!z~$`RP~OY$ZZ]$Z^~$Z~$nTa~Ow$}wx#^x#O$}#O#P%a#P~$}~%QTOw$}wx#^x#O$}#O#P%a#P~$}~%dTOw$}wx%sx#O$}#O#P%a#P~$}~%xTT~Ow$}wx#^x#O$}#O#P%a#P~$}~&^Pa~!Q![&a~&fPU~!Q![&a~&pPU~a~!Q![&a~&xOZ~~'PSc~a~!Q![']!c!}']#R#S']#T#o']~'bSc~!Q![']!c!}']#R#S']#T#o']~'sOW~~'xOV~",
  tokenizers: [0],
  topRules: {"Program":[0,2]},
  specialized: [{term: 17, get: value => spec_singleByteIdentifier[value] || -1},{term: 19, get: value => spec_wordIdentifier[value] || -1}],
  tokenPrec: 0
});

const golfScriptLanguage = LRLanguage.define({
    parser: parser.configure({
        props: [
            styleTags({
                Identifier: tags.definition(tags.variableName),
                Builtin: tags.variableName,
                Number: tags.number,
                String: tags.string,
                LineComment: tags.lineComment,
                "{ }": tags.brace,
                ":": tags.updateOperator
            })
        ]
    }),
    languageData: {
        commentTokens: { line: "#" }
    }
});
function golfScript() {
    return new LanguageSupport(golfScriptLanguage, 
    // limit bracket matching to just the delimeters specified in syntax.grammar
    bracketMatching({ brackets: "{}" }));
}

export { golfScript, golfScriptLanguage };
